import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { FaTrailer } from 'react-icons/fa'
import useStore from '../../store'
import DashboardContainer from '../common/DashboardContainer'
import Breadcrumbs from '../common/Breadcrumbs'
import LocationInformationWidget from './LocationInformationWidget'
import DealerInformationWidget from './DealerInformationWidget'
import OtherLocationsWidget from './OtherLocationsWidget'

export default function TrailerLocation() {
  const { locationId } = useParams()

  const trailerLocation = useStore((state) => state.trailerLocation)
  const fetchTrailerLocation = useStore((state) => state.fetchTrailerLocation)

  useEffect(() => {
    fetchTrailerLocation(locationId)
  }, [locationId])

  const isLocationLoaded = trailerLocation?.id === locationId
  const attributes = isLocationLoaded ? trailerLocation.attributes ?? {} : {}

  return (
    <DashboardContainer>
      <Breadcrumbs />
      {isLocationLoaded && (
        <div className="relative w-full flex items-center justify-center">
          <div className="sticky text-center z-30 pb-2 lg:pb-3 px-2 rounded-t">
            <div className="flex items-center justify-center gap-2 font-black text-2xl mt-1">
              <FaTrailer className="shrink-0" title="Trailer location" />
              {attributes.name ?? 'No Name'}
            </div>
          </div>
        </div>
      )}
      <LocationInformationWidget location={isLocationLoaded ? trailerLocation : null} isFetching={!isLocationLoaded} />
      <DealerInformationWidget dealer={attributes.dealer} isFetching={!isLocationLoaded} />
      <OtherLocationsWidget locations={attributes.other_dealer_locations} isFetching={!isLocationLoaded} />
    </DashboardContainer>
  )
}
